import "core-js/modules/es.array.concat.js";
import WebpPicture from '~/components/WebpPicture.vue';
import Follow from '~/components/profile/Follow.vue';
export default {
  __name: 'VacancyAuthor',
  props: ['company', 'followers'],
  setup: function setup(__props) {
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $modalityStore = _useNuxtApp.$modalityStore;
    var usersListStore = useUsersListStore();
    var location = computed(function () {
      var location = '';
      if (props.company.country) location = props.company.country;
      if (props.company.city) {
        if (location.length) location = "".concat(location, ", ");
        location = "".concat(location).concat(props.company.city);
      }
      return location;
    });
    var readersOpen = computed(function () {
      return $modalityStore.drawer == 'usersList' && usersListStore.id == "subs-".concat(props.company.id);
    });
    function showSubscribers() {
      usersListStore.update({
        id: "subs-".concat(props.company.id),
        url: '/user/getsubscribers',
        title: 'readers',
        params: {
          model: 'company',
          id: props.company.id
        }
      });
    }
    return {
      __sfc: true,
      props: props,
      $modalityStore: $modalityStore,
      usersListStore: usersListStore,
      location: location,
      readersOpen: readersOpen,
      showSubscribers: showSubscribers,
      WebpPicture: WebpPicture,
      Follow: Follow
    };
  }
};